// Utils / Constants
import { decodeHtml } from 'NewAngular/utils/html-transcode';
import { YChartsSentryUtils } from 'NewAngular/services/sentry/sentry-utils';
import { GlossaryService } from 'GlossaryApp/ts/services/glossary.service';
import * as i0 from "@angular/core";
import * as i1 from "GlossaryApp/ts/services/glossary.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
function MetricInfoModalComponent_div_3_li_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "li", 7);
} if (rf & 2) {
    const assetType_r1 = ctx.$implicit;
    i0.ɵɵproperty("textContent", assetType_r1);
} }
function MetricInfoModalComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 5);
    i0.ɵɵtext(2, "Available for:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ul");
    i0.ɵɵtemplate(4, MetricInfoModalComponent_div_3_li_4_Template, 1, 1, "li", 6);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const assetTypes_r2 = ctx.ngIf;
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", assetTypes_r2);
} }
function MetricInfoModalComponent_div_4_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
} if (rf & 2) {
    const section_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("textContent", section_r3.header);
} }
function MetricInfoModalComponent_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MetricInfoModalComponent_div_4_div_1_div_1_Template, 1, 1, "div", 9);
    i0.ɵɵelement(2, "p", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const section_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", section_r3.content);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", section_r3.content, i0.ɵɵsanitizeHtml);
} }
function MetricInfoModalComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, MetricInfoModalComponent_div_4_div_1_Template, 3, 2, "div", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sections_r4 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", sections_r4);
} }
/**
 * Metric Info Modal
 *
 * A modal that displays when the user clicks the info icon next to a metric in the metric modal.
 * For the corresponding metric, this info modal shows the available asset types and other information such as the
 * definition and formula.
 */
export class MetricInfoModalComponent {
    constructor(glossaryService) {
        this.glossaryService = glossaryService;
        this.glossaryTerm = null;
        this.isOpen = false;
        this.metric = null;
    }
    openModal(metric) {
        this.isOpen = true;
        this.metric = metric;
        this.glossaryService.getGlossaryCalcTerm(metric.internal_name).subscribe({
            next: (glossaryTerm) => {
                if (Object.keys(glossaryTerm)) {
                    this.glossaryTerm = glossaryTerm;
                    this.glossaryTerm.sections[0].content = decodeHtml(this.glossaryTerm.sections[0].content, '<br>');
                    this.glossaryTerm.sections[1].content = decodeHtml(this.glossaryTerm.sections[1].content, '<br>');
                }
                else {
                    this.glossaryTerm = null;
                }
            },
            error: (error) => {
                if (error.status !== 404) {
                    YChartsSentryUtils.captureException(error);
                }
            },
        });
    }
    closeModal() {
        this.isOpen = false;
        this.metric = null;
        this.glossaryTerm = null;
    }
}
MetricInfoModalComponent.ɵfac = function MetricInfoModalComponent_Factory(t) { return new (t || MetricInfoModalComponent)(i0.ɵɵdirectiveInject(i1.GlossaryService)); };
MetricInfoModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MetricInfoModalComponent, selectors: [["ycn-metric-info-modal"]], decls: 5, vars: 5, consts: [[3, "closeModalHandler", "extraModalClasses", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], ["class", "modal-section section-info", 4, "ngIf"], [1, "modal-section", "section-info"], [1, "modal-section-title"], [3, "textContent", 4, "ngFor", "ngForOf"], [3, "textContent"], [4, "ngFor", "ngForOf"], ["class", "modal-section-title", 3, "textContent", 4, "ngIf"], [3, "innerHTML"], [1, "modal-section-title", 3, "textContent"]], template: function MetricInfoModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function MetricInfoModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function MetricInfoModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, MetricInfoModalComponent_div_3_Template, 5, 1, "div", 3)(4, MetricInfoModalComponent_div_4_Template, 2, 1, "div", 3);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("extraModalClasses", "modal-sm")("open", ctx.isOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", (ctx.metric == null ? null : ctx.metric.label) || "");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.metric && ctx.metric.available_asset_types);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.glossaryTerm && ctx.glossaryTerm.sections);
    } }, dependencies: [i2.NgForOf, i2.NgIf, i3.ModalBaseComponent, i4.SimpleModalHeaderComponent], encapsulation: 2 });
